import React, { useState, useEffect } from "react";
import { ColumnConfigProvider } from "../../../components/controls/tables/ColumnConfigProvider";
import { Get_HEALTH_STATUS_COLUMNS } from "../../../helpers/columns";
import Table from "../../../components/controls/tables/Table";
const HealthTable = ({
  projectHealth,
  dashboardFilterSetId,
  dashboardFilterSetName,
  entityType,
  loading,
  onComponentReady,
}) => {
  const [isHeader, setIsHeader] = useState(true);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const handleSearch = (filteredData) => {
    if(filteredData === null)
      setData(originalData);
    else
      setData(filteredData);
  };

  useEffect(() => {
    setData(projectHealth || []);
    setOriginalData(projectHealth || []);
  }, [projectHealth]);

  useEffect(() => {
    if (onComponentReady) {
      const timeout = setTimeout(() => {
        onComponentReady();
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <>
      <ColumnConfigProvider
        tableName={"HealthStatus"}
        columns={Get_HEALTH_STATUS_COLUMNS(entityType)}
      >
        {/* <ListingHeader
          type="HealthStatus"
          searchedData={handleSearch}
          setIsCreate={() => setIsCreate(true)}
          rightPane={false}
          healthData={projectHealth}
        />
        <TableComponent
          customTableScrollClass={`${
            isHeader ? "Roles_ResourcesScreenScroll" : "TabsHeaderListingScroll"
          } DashboardTable-Risk DashboardTable-Health`}
          type="HealthStatus"
          rows={data || []}
          title="Project Health Status"
          setIsCreate={setIsCreate}
          dashboardFilterSetId={dashboardFilterSetId}
          dashboardFilterSetName={dashboardFilterSetName}
          loadingSkeleton={loadingHealth}
        /> */}

        <Table
          type="HealthStatus"
          isHeader={isHeader}
          rows={data || []}
          overviewType="Dashboard"
          searchHandler={handleSearch}
          setIsCreate={setIsCreate}
          loading={loading}
          isCreate={isCreate}
        />
      </ColumnConfigProvider>
    </>
  );
};

export default HealthTable;
